import React from 'react';
import { Layout } from 'antd';
import { RobotOutlined, CodeOutlined } from '@ant-design/icons';

const { Footer: AntdFooter } = Layout;

interface FooterProps {
  textColor?: string;
}

const Footer: React.FC<FooterProps> = ({ textColor = '#666' }) => {
  return (
    <AntdFooter
      style={{
        textAlign: 'center',
        background: 'transparent',
        color: textColor,
        padding: '16px 0',
        marginTop: 'auto',
        position: 'relative',
        bottom: 0,
        width: '100%',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '8px',
          fontSize: '14px',
          fontWeight: 500,
        }}
      >
        <RobotOutlined
          style={{
            fontSize: '16px',
            color: textColor,
          }}
        />
        <span>100% AI-engineered by</span>
        <span
          style={{
            fontWeight: 600,
            color: '#4ecdc4',
          }}
        >
          Claude Code
        </span>
        <CodeOutlined
          style={{
            fontSize: '16px',
            color: textColor,
            marginLeft: '4px',
          }}
        />
      </div>
    </AntdFooter>
  );
};

export default Footer;